module.exports = __webpack_public_path__ + "img/05.9d2d80d5.png";